import { lazy, Suspense } from 'react';
import { type RouteObject } from 'react-router';
import { Guard } from '@/modules/shared/components/guard';

const SuperHome = lazy(() => import('./pages/home'));
const Auditoria = lazy(() => import('./pages/auditoria'));

const CadastrosLayout = lazy(() => import('./pages/cadastros/_layout'));
const CadastrosIndex = lazy(() => import('./pages/cadastros/index'));
const Escola = lazy(() => import('./pages/cadastros/escola'));
const Administradores = lazy(() => import('./pages/cadastros/administradores'));

const SuperGuard = ({ children, allowedRoles }: {
  children: React.ReactNode;
  allowedRoles: any[];
}) => (
  <Suspense fallback={<div className="min-h-screen" />}>
    <Guard allowedRoles={allowedRoles} allowSuperWithoutSchool>
      {children}
    </Guard>
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <SuperGuard allowedRoles={['SUPER']}>
        <SuperHome />
      </SuperGuard>
    ),
    handle: { crumb: 'Home' }
  },
  {
    path: '/super/auditoria',
    element: (
      <Suspense fallback={<div className="min-h-screen" />}>
        <Guard allowedRoles={['SUPER']}>
          <Auditoria />
        </Guard>
      </Suspense>
    ),
    handle: { crumb: 'Auditoria' }
  },
  {
    path: '/super/cadastros',
    element: (
      <SuperGuard allowedRoles={['SUPER']}>
        <CadastrosLayout />
      </SuperGuard>
    ),
    handle: { crumb: 'Cadastros' },
    children: [
      {
        index: true,
        element: <CadastrosIndex />,
      },
      {
        path: 'escola',
        element: <Escola />,
        handle: { crumb: 'Escolas' }
      },
      {
        path: 'administradores',
        element: <Administradores />,
        handle: { crumb: 'Administradores' }
      }
    ]
  }
];

export default routes;
